import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2035ParamStatus: 'idle',
    startProcess2035ParamError: undefined as any,
    loadUserParamsProcess2035ParamStatus: 'idle',
    loadUserParamsProcess2035ParamError: undefined as any,

    process2035ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2035Param = createAsyncThunk('process2035ParamSlice/startProcess2035Param', async ({ process2035Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2035Param/`,
        prepareData(process2035Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2035ParamStatus } = getState().process2035ParamSlice
        return startProcess2035ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess2035Param = createAsyncThunk('process2035ParamSlice/loadUserParamsProcess2035Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2035Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2035ParamStatus } = getState().process2035ParamSlice
        return loadUserParamsProcess2035ParamStatus !== 'pending'
    }
})

const Process2035ParamSlice = createSlice({
    name: 'process2035ParamSlice',
    initialState,
    reducers: {
        resetstartProcess2035Param: (state) => {
            state.job = undefined
            state.startProcess2035ParamError = undefined
        },
        resetstartProcess2035ParamError: (state) => {
            state.startProcess2035ParamError = undefined
        },
        resetloadUserParamsProcess2035Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2035ParamError = undefined
        },
        resetloadUserParamsProcess2035ParamError: (state) => {
            state.loadUserParamsProcess2035ParamError = undefined
        },
        removeFromProcess2035ParamListById: (state, action) => {
            state.process2035ParamList = state.process2035ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2035ParamListByIds: (state, action) => {
            state.process2035ParamList = state.process2035ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2035ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2035ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2035ParamList = []
            state.startProcess2035ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2035Param.pending, (state) => {
            state.startProcess2035ParamStatus = 'pending'
            state.startProcess2035ParamError = undefined
        })
        builder.addCase(startProcess2035Param.fulfilled, (state, action) => {
            state.startProcess2035ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2035Param.rejected, (state, action) => {
            state.startProcess2035ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2035ParamError = action.error.message
            } else {
                state.startProcess2035ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2035Param.pending, (state) => {
            state.loadUserParamsProcess2035ParamStatus = 'pending'
            state.loadUserParamsProcess2035ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess2035Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess2035ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2035Param.rejected, (state, action) => {
            state.loadUserParamsProcess2035ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2035ParamError = action.error.message
            } else {
                state.loadUserParamsProcess2035ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2035Param,
    resetstartProcess2035ParamError,
    resetloadUserParamsProcess2035Param,
    resetloadUserParamsProcess2035ParamError,
    removeFromProcess2035ParamListById,
    removeFromProcess2035ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2035ParamSlice.actions
export default Process2035ParamSlice.reducer
